import LoadingConstants from 'app/shared/constants/LoadingConstants';
import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    loadingState: LoadingConstants.INITIAL,
    paymentMethodLock: false,
    accountPaymentMethods: [],
    isAutopayEnabled: false,
    autopayMethodId: null,
    defaultPaymentMethod: null,
    accountName: '',
    canAccessAch: false,
});

const accountPaymentMethods = (state = initState(), action = {}) => {
    const { type, payload } = action;
    switch (type) {
        case DispatchConstants.BILLING_ACCOUNT_PAYMENT_METHODS_INIT:
            return initState();
        case DispatchConstants.BILLING_ACCOUNT_PAYMENT_METHODS_SET_LOADING_STATE:
            return {
                ...state,
                loadingState: payload,
            };
        case DispatchConstants.BILLING_ACCOUNT_PAYMENT_METHODS_SET_PAYMENT_METHODS:
            return {
                ...state,
                loadingState: LoadingConstants.SUCCESS,
                paymentMethodLock: payload.paymentMethodLock,
                autopayOwnerId: payload.autopayOwnerId,
                isAutopayEnabled: payload.isAutopayEnabled,
                autopayMethodId: payload.autopayMethodId,
                accountPaymentMethods: payload.paymentMethods,
                defaultPaymentMethod: payload.defaultPaymentMethod,
                accountName: payload.accountName,
                canAccessAch: payload.canAccessAch,
            };
        case DispatchConstants.BILLING_ACCOUNT_PAYMENT_METHODS_SET_PAYMENT_METHOD_LOCK:
            return {
                ...state,
                paymentMethodLock: payload.paymentMethodLock,
            };
        default:
            return state;
    }
};

export default accountPaymentMethods;
